<template>
  <Component
    :is="featureComponents[feature]"
    v-for="feature in availableFeatures"
    :key="feature"
  />
</template>

<script setup>
import {
  featureComponents
} from "#blokkli-build/features";
import { useBlokkli, onMounted, nextTick, computed } from "#imports";
const emit = defineEmits(["loaded"]);
const { adapter, features, ui, debug } = useBlokkli();
const logger = debug.createLogger("Features");
const renderedFeatures = computed(
  () => features.mountedFeatures.value.map((v) => v.id)
);
const disabledFeatures = adapter.getDisabledFeatures ? await adapter.getDisabledFeatures() : await Promise.resolve([]);
const availableFeatures = computed(() => {
  return features.features.value.filter((v) => {
    if (disabledFeatures.includes(v.id)) {
      return false;
    }
    if (v.requiredAdapterMethods?.length && !v.requiredAdapterMethods.every((method) => adapter[method])) {
      return false;
    }
    if (v.dependencies?.length && !v.dependencies.every((id) => renderedFeatures.value.includes(id))) {
      return false;
    }
    if (v.beta && !features.enabledBetaFeatures.value.includes(v.id)) {
      return false;
    }
    return !v.viewports?.length || v.viewports.includes(ui.appViewport.value);
  }).map((v) => {
    return v.id;
  });
});
onMounted(() => {
  nextTick(() => {
    emit("loaded");
    logger.log("Features loaded", renderedFeatures.value);
  });
});
</script>

<script>
export default {
  name: "Features"
};
</script>
